import { useFilterMapper } from '@nexelem/filters';
import { Header } from '@nexelem/header';
import { useTranslation } from 'react-i18next';
import { ActiveFilterBadge } from '../../../../../molecules/filters/ActiveFilterBadge';
import { HeaderProps } from '../../../../FilteredGridPage/types';
import { Button } from '@nexelem/components';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../../../routes/config';
import { useCustomTranslation } from '../../../../../../hooks';
import { isEmpty } from 'lodash';
import { CreateOrEditFilterButton } from '../../../../../../components/molecules/filters/CreateOrEditFilterModal';
import { simulationListFilterMapper } from './simulationListFilterMapper';
import { useAuthContext } from '../../../../../../providers/AuthProvider';
import { PERMS } from '../../../../../../routes/permissions';

export const SimulationListHeader = ({ title, filters, store }: HeaderProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { t } = useTranslation();
  const filterMapper = useFilterMapper(simulationListFilterMapper());
  const { hasPermission } = useAuthContext();
  const canEditSimulation = hasPermission(PERMS.PERM_12);

  return (
    <Header subTitle={<ActiveFilterBadge store={store} />} title={t(title)}>
      <CreateOrEditFilterButton disabled={isEmpty(filterMapper(filters))} filters={filters} store={store} />
      {canEditSimulation && (
        <Button component={Link} to={ROUTES.plan.simulationCreatePath} variant="contained">
          {tWrapper('createSimulation')}
        </Button>
      )}
    </Header>
  );
};
